<div class="col-md-12">
  <h3 class="">VOWD Details Report</h3>
  <hr style="margin: 0;border: lightgray solid 0.5px; ">
<br />

<div class="panel panel-primary">
  <div class="panel-heading">Search Information</div>
  <div class="panel-body">
  <div class="form">
      
    <div class="form-group row">
      <label for="SupplierNamelbl" class="col-sm-2 col-form-label">Supplier Name:</label>
      <div class="col-sm-4">
              <input placeholder="All" name="SupplierNamelbl" id="SupplierNamelbl" type="text" class="form-control" [(ngModel)]="SupplierAB" [ngbTypeahead]="searchSupplier"/>
</div>
   
      <label for="ObjectAccountlbl" class="col-sm-2 col-form-label">Object Account:</label>
      <div class="col-sm-4">
       
        <input placeholder="All" name="ObjectAccountlbl" id="ObjectAccountlbl" type="text" class="form-control" [(ngModel)]="ObjectAccount" [ngbTypeahead]="searchObjectAcnt"/>
      </div>
    </div>
     <div class="form-group row">
      <label for="Arealbl1" class="col-sm-2 col-form-label">Area:</label>
      <div class="col-sm-4">
       
        <input placeholder="All" name="Arealbl1" id="Arealbl1" type="text" class="form-control" [(ngModel)]="Area" [ngbTypeahead]="searchArea"/>
      </div>
   
      <label for="Departmentlbl1" class="col-sm-2 col-form-label">Department:</label>
      <div class="col-sm-4">
       
        <input placeholder="All" name="Departmentlbl1" id="Departmentlbl1" type="text" class="form-control" [(ngModel)]="Department" [ngbTypeahead]="searchDepartment"/>
      </div>
    </div>  
    <div class="form-group row">
        <label for="Yearlbl" class="col-sm-2 col-form-label">Year:</label>
        <div class="col-sm-4">
            <select id="Yearlbl" class="form-control" [(ngModel)]="Year" >
                <option value="" selected>All</option>
                <option *ngFor="let _yrs of getYrs" [ngValue]="_yrs" >{{_yrs}}</option>
              </select>
          
        </div>
      </div>
      <div class="form-group row">
          <label for="Monthlbl" class="col-sm-2 col-form-label">Month:</label>
          <div class="col-sm-4">
              <select id="Monthlbl" class="form-control" [(ngModel)]="Month" >
                  <option value="" selected>All</option>
                  <option *ngFor="let _month of getMonths" [ngValue]="_month" >{{_month}}</option>
                </select>
          </div>
      </div>
    <div class="form-group row">
      <div class="col-sm-2 col-form-label"></div>
      <div class="col-sm-4">
        <button class="btn btn-primary"  (click)="getVOWD()" >Search</button>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
</div>
  <br /> <br />
  
      <table class="table table-bordered" *ngIf="vowdResult.length > 0" >
          <thead>
            <tr>
                <th scope="col" >Supplier Name</th>
                <th scope="col" >Supplier AB#</th>
                <th scope="col" >Cost Center</th>
                <th scope="col" >Object Account</th>
                <th scope="col" >Period </th>
                <th scope="col" >Division </th>
                <th scope="col" >Company Code </th>
                <th scope="col" >Area </th>
                <th scope="col" >Department </th>
                <th scope="col" >VOWD Amt </th>
                <th scope="col" >CreatedBy </th>
               
                <th scope="col" >Description </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let res of vowdResult | paginate: { itemsPerPage: 10, currentPage: p}">
                <td>{{res.SupplierName}} </td>
                <td>{{res.SupplierAB}} </td>
                <td>{{res.CostCenter}}</td>
                <td>{{res.ObjDescr}}</td>
                <td>{{res.Period}}</td>
                <td>{{res.DivisionField}}</td>
                <td>{{res.CompanyCode}}</td>
                <td>{{res.Area_CODE}}-{{res.Area_description }}</td>
                <td>{{res.Division }}</td>
                <td>{{res.VOWDAmount| currency}}</td>
                <td>{{res.CreatedBy|uppercase }}</td>
                
                <td>{{res.DescrOfWork}}</td>
            </tr>
          </tbody>
         <tfoot>
          <b>Total VOWD: {{vowdTotal| currency}}</b> 
         </tfoot>
      </table>
      <pagination-controls (pageChange)="p = $event" *ngIf="vowdResult.length > 0"></pagination-controls>
      
  <div class="form-group row" *ngIf="vowdResult.length > 0">
      <div class="col-sm-4">
        <button (click)="ExportTOExcel()"  class="btn btn-primary">ExportTOExcel</button>
      </div>
  </div>  
  <table class="table table-bordered hidden"  id="reportGrid_all">
    <thead>
      <tr>
          <th scope="col" >Supplier Name</th>
          <th scope="col" >Supplier AB#</th>
          <th scope="col" >Cost Center</th>
          <th scope="col" >Object Account</th>
          <th scope="col" >Period </th>
          <th scope="col" >Division </th>
          <th scope="col" >Company Code </th>
          <th scope="col" >Area </th>
          <th scope="col" >Department </th>
          <th scope="col" >VOWD Amt </th>
          <th scope="col" >CreatedBy </th>
          
          <th scope="col" >Description </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let res of vowdResult">
          <td title="Supplier Name">{{res.SupplierName}} </td>
          <td title="Supplier AB#">{{res.SupplierAB}} </td>
          <td title="Cost Center">{{res.CostCenter}}</td>
          <td title="Object Account">{{res.ObjDescr}}</td>
          <td title="Period">{{res.Period}}</td>
          <td title="Division">{{res.DivisionField}}</td>
          <td title="Company Code">{{res.CompanyCode}}</td>
          <td title="Area">{{res.Area_CODE}}-{{res.Area_description }}</td>
          <td title="Department">{{res.Division }}</td>
          <td title="VOWD Amt">{{res.VOWDAmount| currency}}</td>
          <td title="Created By">{{res.CreatedBy}}</td>
         
          <td title="Description">{{res.DescrOfWork}}</td>
      </tr>
    </tbody>
</table>